import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=685cf636&"
import script from "./LayoutNavigation.vue?vue&type=script&lang=ts&"
export * from "./LayoutNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports